import getApi from '../../../api/apisauceConfig'
import { PendingDoctolibPatientData } from '../../../model/Doctolib'

export const getPendingPatientData = (patientId: number) =>
  getApi().get<PendingDoctolibPatientData[]>(`/patients/${patientId}/pending_changes`)
